import { Col, Flex, Row, Skeleton } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { styled } from "styled-components";
import { StyledAnalyticsCard } from "./ProjectAnalyticsStatCard";

export const ProjectAnalyticsStatCardSkeleton: React.FC = () => {
  const { theme } = useAntTheme();

  return (
    <Row gutter={[10, 10]}>
      {["views", "engagement", "completion"].map((name) => (
        <Col xs={24} sm={8} key={`skeleton-card-${name}`}>
          <StyledAnalyticsCard
            $backgroundColor={theme.colorCardSecondaryRedesign}
            styles={{
              body: { padding: 10, height: "100%" },
            }}
          >
            <Flex
              vertical
              gap={10}
              justify="space-between"
              style={{ height: "100%" }}
            >
              <StyledSkeletonInput active size="small" style={{ height: 20 }} />
              <StyledSkeletonInput active size="large" style={{ height: 30 }} />
              <Skeleton.Button active block style={{ height: 60 }} />
            </Flex>
          </StyledAnalyticsCard>
        </Col>
      ))}
    </Row>
  );
};

const StyledSkeletonInput = styled(Skeleton.Input)`
  &.ant-skeleton-input {
    width: 98% !important;
    min-width: 98% !important;
  }
`;
